import { useEffect, useState } from "react";
import { Box, Button, HStack, VStack, useToast } from "@chakra-ui/react";
import Select from "react-select";
import axios from "axios";
import { useSelector } from "react-redux";

const BASE_URL = "https://develop-project-360.onrender.com";

// API call to add members
export const addMemberToProject = (projectId, userIds) =>
  axios.post(`${BASE_URL}/${projectId}/add-member`, { userId: userIds });

// API to fetch users by adminId or companyId
const fetchUsers = async (adminId) => {
  const res = await axios.get(`${BASE_URL}/getUserById`, {
    params: { adminId },
  });
  return res.data;
};

const MemberAssignment = ({ projectId, adminId }) => {
  const adminIdGlobal = useSelector((store) => store.authentication.users.id);
  const toast = useToast();
  const [allUsers, setAllUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedTeamLead, setSelectedTeamLead] = useState(null);
  const [filteredTeamLeads, setFilteredTeamLeads] = useState([]);

  useEffect(() => {
    fetchUsers(adminIdGlobal)
      .then((users) => {
        setAllUsers(users);

        const uniqueDepartments = [
          ...new Set(users.map((u) => u.department).filter(Boolean)),
        ];
        setDepartments(
          uniqueDepartments.map((dept) => ({ label: dept, value: dept }))
        );
      })
      .catch(() => toast({ title: "Failed to fetch users", status: "error" }));
  }, [adminIdGlobal, toast]);

  useEffect(() => {
    if (selectedDepartments.length === 0) {
      setFilteredUsers([]);
      setFilteredTeamLeads([]);
    } else {
      const selectedDeptValues = selectedDepartments.map((d) => d.value);

      const filtered = allUsers.filter((user) =>
        selectedDeptValues.includes(user.department)
      );
      setFilteredUsers(filtered);

      //   const teamLeads = filtered.filter((user) => user.role === "teamlead");
      const teamLeads = filtered.filter(
        (user) => user.role === "teamlead" && user.adminId === adminIdGlobal
      );

      setFilteredTeamLeads(teamLeads);
    }
  }, [selectedDepartments, allUsers, adminIdGlobal]);

  const handleAssign = async () => {
    const userIds = selectedUsers.map((user) => user.value);
    const teamLeadId = selectedTeamLead?.value;

    if (userIds.length === 0 && !teamLeadId) {
      toast({ title: "Select members or a team lead", status: "warning" });
      return;
    }

    try {
      await addMemberToProject(projectId, userIds); // You may want to update this to support teamLeadId too
      // optionally handle assigning team lead in a separate request

      toast({ title: "Members and team lead added", status: "success" });
      setSelectedUsers([]);
      setSelectedDepartments([]);
      setSelectedTeamLead(null);
    } catch {
      toast({ title: "Error adding members", status: "error" });
    }
  };

  return (
    <Box p={1} borderWidth="1px" rounded="md">
      <HStack spacing={8}>
        <Select
          isMulti
          options={departments}
          placeholder="Select Department(s)"
          value={selectedDepartments}
          onChange={(selected) => setSelectedDepartments(selected)}
        />

        <Select
          isMulti
          options={filteredUsers.map((user) => ({
            label: user.sudo_name,
            value: user._id,
          }))}
          placeholder="Select Employee(s)"
          value={selectedUsers}
          onChange={(selected) => setSelectedUsers(selected)}
          isDisabled={filteredUsers.length === 0}
        />

        <Select
          options={filteredTeamLeads.map((user) => ({
            label: user.sudo_name,
            value: user._id,
          }))}
          placeholder="Assign Team Lead"
          value={selectedTeamLead}
          onChange={(selected) => setSelectedTeamLead(selected)}
          isClearable
        />

        <Button
          onClick={handleAssign}
          bgGradient="linear(to-r, green.300,  teal.100)"
          _hover={{ bgGradient: "linear(to-r, green.100,  green.400)" }}
          size={"sm"}
        >
          Add Member(s)
        </Button>
      </HStack>
    </Box>
  );
};

export default MemberAssignment;
